export const users = {
  url: import.meta.env.VITE_USERS_SERVICE_URI,
};

export const riskAnalysis = {
  url: import.meta.env.VITE_RISK_ANALYSIS_SERVICE_URI,
};

export const companies = {
  url: import.meta.env.VITE_COMPANIES_SERVICE_URI,
};

// NOTE: `supplierquestionnaire` was removed with the admin questionnaire
// template bulk delete, the last route on the `/supplier-questionnaire-service`
// prefix. Every questionnaire call now goes through `api.backend` on `/api`.

export const audits = {
  url: import.meta.env.VITE_AUDITS_SERVICE_URI,
};

export const cascadeMap = {
  url: import.meta.env.VITE_CASCADE_MAP_SERVICE_URI,
};

export const backend = {
  url: import.meta.env.VITE_BACKEND_URI,
};
